import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "toolkit/store";
import { getCategories } from "src/common/toolkit/features/categories";

const useCategories = () => {
  const dispatch = useDispatch<any>();

  const { categories, loading } = useSelector((state: RootState) => state.categories);

  useEffect(() => {
    if (!categories?.length) {
      dispatch(getCategories({}));
    }
  }, []);

  return {categories, loading};
};

export default useCategories;
